import { Checkbox, Image, Space, Table, Tag, Tooltip, Typography } from "antd"
import { useEffect, useState } from "react"
import "./Viva.css"
import { collection, doc, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import moment from "moment"
import { NavLink } from "react-router-dom"
import { ScissorOutlined } from "@ant-design/icons"
import { ASAPOrder, OrderAndPrefix } from "../../../components/Orders/Helpers/OrderAndPrefix"
import axiosInstance from "../../../axios/axiosConfig"
import "../../../styles/OrderTable.css"
import { formatNumberWithSpaces } from "../../../components/Orders/Helpers/FormatNumbersWithSpaces"
import OrderTicketButton from "../../../components/Tickets/OrderTicketDrawer"
import MakeCurrentlyPrinting from "../../../components/Machines/ActivePrinting/MakeCurrentlyPrinting"
import ActiveOrderBar from "../../../components/Machines/ActiveOrderBar"

const { Text } = Typography

export default function ActiveOrders() {
  const [vivaPrintData, setVivaPrintData] = useState([])
  //array that manages order and gets updates
  const [vivaSequence, setVivaSequence] = useState(vivaPrintData.map((item) => item.id))
  //loading for while data is sorting
  const [isSorting, setIsSorting] = useState(true)
  const [hiddenTechnical, setHiddenTechnical] = useState(true)

  const activeOrder = vivaPrintData.find((r) => r.currentlyInUseForViva)

  let clientFIlters =
    vivaPrintData &&
    vivaPrintData.reduce((accumulator, item) => {
      const clientName = item.client.client
      const existingItem = accumulator.find((filterItem) => filterItem.text === clientName)

      if (existingItem) {
        existingItem.value = clientName
      } else {
        accumulator.push({
          text: clientName,
          value: clientName,
        })
      }

      return accumulator
    }, [])

  let productFilters =
    vivaPrintData &&
    vivaPrintData.reduce((accumulator, item) => {
      const productName = item.selectedProduct.product.productName
      const existingItem = accumulator.find((filterItem) => filterItem.text === productName)

      if (existingItem) {
        existingItem.value = productName
      } else {
        accumulator.push({
          text: productName,
          value: productName,
        })
      }

      return accumulator
    }, [])

  let materialFilter =
    vivaPrintData &&
    vivaPrintData.reduce((accumulator, item) => {
      const materialName = item.selectedProduct.material
      const existingItem = accumulator.find((filterItem) => filterItem.text === materialName)

      if (existingItem) {
        existingItem.value = materialName
      } else {
        accumulator.push({
          text: materialName,
          value: materialName,
        })
      }

      return accumulator
    }, [])

  const vivaPrintingCols = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      width: "10%",
      sorter: (a, b) => a.justOrderNumber - b.justOrderNumber,
      render: (value, record) => (
        <Space>
          {ASAPOrder(record)}
          {OrderAndPrefix(record)}
        </Space>
      ),
    },
    {
      title: "Priority",
      width: "3%",
      dataIndex: "id",
      align: "center",
      render: (id) => vivaSequence.indexOf(id) + 1,
    },
    {
      title: "Created",
      dataIndex: "created",
      align: "center",
      sorter: (a, b) => a.created.seconds - b.created.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD.MM.YYYY")}</Text>
        </>
      ),
    },
    {
      title: "Due D.",
      dataIndex: "orderDueDate",
      align: "center",
      sorter: (a, b) => a.orderDueDate.seconds - b.orderDueDate.seconds,
      key: "created",
      render: (value, record) => {
        const dueDate = moment.unix(value.seconds)
        const isOverdue = dueDate.isBefore(moment(), "day")
        if (isOverdue) {
          return <Tag color="red"> {dueDate.format("DD.MM.YYYY")}</Tag>
        } else {
          return <Tag color="blue">{dueDate.format("DD.MM.YYYY")}</Tag>
        }
      },
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
      ellipsis: {
        showTitle: false,
      },
      filters: clientFIlters,
      onFilter: (value, record) => record.client.client.startsWith(value),
      filterSearch: true,
      render: (item) => (
        <Tooltip placement="topLeft" title={item}>
          {item}
        </Tooltip>
      ),
    },
    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
      filters: productFilters,
      onFilter: (value, record) => record.selectedProduct.product.productName === value,
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (item) => (
        <Tooltip placement="topLeft" title={item}>
          {item}
        </Tooltip>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "labelCount",
      align: "center",
      width: "7%",
      sorter: (a, b) => a.labelCount - b.labelCount,
      render: (value) => <Text>{formatNumberWithSpaces(value)}</Text>,
    },
    {
      title: "Die-cut",
      dataIndex: ["selectedProduct", "knifeCode"],
      align: "center",
    },

    {
      title: "W",
      dataIndex: ["selectedProduct", "labelWidth"],
      align: "center",
      width: "3%",
    },
    {
      title: "H",
      dataIndex: ["selectedProduct", "labelHeight"],
      align: "center",
      width: "3%",
    },
    {
      title: "M.Width",
      dataIndex: ["selectedProduct", "formatWidth"],
      align: "center",
      sorter: (a, b) => a.selectedProduct.formatWidth - b.selectedProduct.formatWidth,
      render: (value, record) => {
        if (record.readRollWidth) {
          return <Text>{record.rollWidth}</Text>
        } else {
          return <Text>{value}</Text>
        }
      },
    },
    {
      title: "Proj. M.",
      dataIndex: ["projectedMeters"],
      align: "center",
      width: "4%",
      render: (value, record) => <Text>{value}m</Text>,
    },
    {
      title: "Material",
      dataIndex: ["selectedProduct", "material"],
      align: "center",
      filters: materialFilter,
      onFilter: (value, record) => record.selectedProduct.material.startsWith(value),
      filterSearch: true,
      ellipsis: {
        showTitle: false,
      },
      render: (item) => (
        <Tooltip placement="topLeft" title={item}>
          {item}
        </Tooltip>
      ),
    },
    {
      title: "Plate",
      dataIndex: ["selectedPlate", "code"],
      align: "center",
      ellipsis: {
        showTitle: false,
      },
      render: (item) => {
        if (item) {
          return (
            <Tooltip placement="topLeft" title={item}>
              {item}
            </Tooltip>
          )
        } else {
          return <ScissorOutlined style={{ color: "#f5222d" }} />
        }
      },
    },
    {
      title: "Technical",
      dataIndex: "technicalPage",
      align: "center",
      render: (value) => (
        <>
          <Image src={value} />
        </>
      ),
    },
    {
      title: "Details",
      align: "center",
      width: "12%",
      render: (value, record) => (
        <Space>
          <NavLink state={value} to={"/viva/orders/" + value.id}>
            {value ? "Fill Order" : ""}
          </NavLink>
          <OrderTicketButton order={value} />
          <MakeCurrentlyPrinting
            machine="Viva"
            orderId={record.id}
            currentlyInUse={record.currentlyInUseForViva}
            startedAt={record.jobStartedAtViva}
            exclusive
          />
        </Space>
      ),
    },
  ]

  //gets array of the sequence
  useEffect(() => {
    const sequenceDocRef = doc(db, "sequence", "documentForVivaSequence")
    const unsubscribe = onSnapshot(sequenceDocRef, (doc) => {
      if (doc.exists()) {
        const sequenceData = doc.data()
        setVivaSequence(sequenceData.vivaSequence)
        console.log("sequence")
      }
    })
    return () => unsubscribe()
  }, [])

  // //fetches the documents, then uses the sequence array to sort in correct order
  useEffect(() => {
    const ref = collection(db, "orders")
    let q = query(
      ref,
      where("orderStatus", "==", 4),
      where("selectedProduct.machine", "==", "Viva"),
    )

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      let orders = snapshot.docs.map((doc) => ({
        ...doc.data(),
        key: doc.id,
        id: doc.id,
      }))

      // Fetch knife data and calculate projected meters in batch
      const ordersWithKnifeData = await Promise.all(
        orders.map(async (order) => {
          if (
            order.selectedProduct.knifeCode === undefined ||
            order.selectedProduct.knifeCode === "none"
          ) {
            return { ...order, projectedMeters: 0 } // No knife code, set projected meters to 0
          }
          try {
            const response = await axiosInstance.get(
              `/api/searchByCode?code=${encodeURIComponent(order.selectedProduct.knifeCode)}`,
            )
            const knife = response.data
            const correctColumns = order.selectedProduct.numberOfColumns

            const countInThousands = order.labelCount / 1000
            const a1 = (knife.height + knife.gapRaport) * 0.001
            const a2 = Number((1000 / correctColumns).toFixed(2))
            const a3 = Math.ceil(a1 * a2)
            const a4 = Number((a3 * countInThousands).toFixed(2))

            return { ...order, projectedMeters: a4 }
          } catch (error) {
            console.error("Failed to fetch knife data:", error)
            return { ...order, projectedMeters: 0 } // In case of error, set projected meters to 0
          }
        }),
      )

      // Sort orders based on their sequence by finding the index of each order's ID in the vivaSequence array
      const sortedOrders = ordersWithKnifeData.sort((a, b) => {
        return vivaSequence.indexOf(a.id) - vivaSequence.indexOf(b.id)
      })

      setVivaPrintData(sortedOrders)
      setIsSorting(false)
    })

    return () => unsubscribe()
  }, [vivaSequence]) // Dependency on vivaSequence ensures re-sort if sequence changes

  // Filter for hiding technical page
  const changeFilter = () => {
    setHiddenTechnical(!hiddenTechnical)
  }

  const columnsToShow = hiddenTechnical
    ? vivaPrintingCols.filter((col) => col.dataIndex !== "technicalPage")
    : vivaPrintingCols

  return (
    <>
      <ActiveOrderBar order={activeOrder} machine="Viva" showProjectedMeters />

      <Checkbox style={{ marginBottom: 15 }} defaultChecked onChange={changeFilter}>
        Hide/Show Technical
      </Checkbox>
      <Table
        bordered
        size="small"
        className="custom-table"
        rowKey={(record) => record.id}
        dataSource={vivaPrintData}
        loading={isSorting}
        columns={columnsToShow}
        rowClassName={(record) => {
          const classes = []
          if (record.priorityOrder) classes.push("red-background")
          if (record.currentlyInUseForViva) classes.push("active-row")
          return classes.join(" ")
        }}
        pagination={{ pageSize: 40, showSizeChanger: true }}
      />
    </>
  )
}
